"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * EMIL InsuranceService
 * The EMIL InsuranceService API description
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kontakt@emil.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatchDraftPolicyRequestDtoRevisionStatusEnum = void 0;
exports.PatchDraftPolicyRequestDtoRevisionStatusEnum = {
    Created: 'CREATED',
    InReview: 'IN_REVIEW',
    Reviewed: 'REVIEWED',
    Rejected: 'REJECTED',
    Approved: 'APPROVED'
};
